<template>
  <div>
    <h3 class="co-display-10 mb-2 border-b pb-4 text-center font-bold">
      <FontAwesomeIcon
        :icon="faCircleInfo"
        class="fa-fw mr-2 inline size-5 text-co-info-500"
      />
      分割払いをご利用いただけます
    </h3>

    <div
      v-if="installment || installmentsSocial || installmentsSocial8Week || twelveWeek"
      class="co-display-10 mb-2 flex flex-col justify-center lg:flex-row"
    >
      <div class="text-center lg:w-1/2">
        <b class="font-normal">
          月々約
          <span class="co-display-6 px-2 font-bold">
            <template v-if="installment">
              {{ $addComma(installment) }}
            </template>
            <template v-else-if="installmentsSocial">
              {{ $addComma(social4WeeksPlan.price_for_max_installment) }}
            </template>
            <template v-else-if="installmentsSocial8Week">
              {{ $addComma(social8WeeksPlan.price_for_max_installment) }}
            </template>
            <template v-else-if="twelveWeek">
              {{ $addComma(social12WeeksPlan.price_for_max_installment) }}
            </template>
          </span>
          円〜
        </b>
      </div>
    </div>

    <div
      v-else
      class="co-display-10 mb-2 flex flex-col lg:flex-row lg:gap-x-8"
    >
      <div class="text-center lg:w-1/2">
        <b class="font-normal">
          社会人の方は月々約
          <span class="co-display-6 px-2 font-bold">
            {{ $addComma(social4WeeksPlan.price_for_max_installment) }}
          </span>
          円〜
        </b>
      </div>
      <div class="text-center lg:w-1/2">
        <b class="font-normal">
          学生の方は月々約
          <span class="co-display-6 px-2 font-bold">
            {{ $addComma(student4WeeksPlan.price_for_max_installment) }}
          </span>
          円〜
        </b>
      </div>
    </div>

    <p
      v-if="onePlan"
      class="co-display-13 mb-1 text-center text-co-gray-500"
    >
      ※上記の値段は24回払いの場合となります。
    </p>
    <p
      v-else-if="twelveWeek"
      class="co-display-13 mb-1 text-center text-co-gray-500"
    >
      ※上記の値段は12週間プランを24回払いの場合となります。
    </p>
    <p
      v-else-if="fourLitePayments"
      class="co-display-13 mb-1 text-center text-co-gray-500"
    >
      ※上記の値段は4週間Liteプラン24回払いの場合となります。
    </p>
    <p
      v-else-if="installmentsSocial8Week"
      class="co-display-13 mb-1 text-center text-co-gray-500"
    >
      ※上記の値段は8週間プランを24回払いの場合となります。
    </p>
    <p
      v-else
      class="co-display-13 mb-1 text-center text-co-gray-500"
    >
      ※上記の値段は4週間プランを24回払いの場合となります。
    </p>
    <p class="co-display-13 mb-[3.25rem] text-center text-co-gray-500">
      ※分割手数料については、ご契約のカード会社によって異なりますので、直接カード会社にお問い合わせください。
    </p>
    <!-- クラウドローンバナー -->
    <!-- Educareテスト開始、クラウドローンバナーはコメントアウト -->
    <!-- <TeCommonBannerCrowdloan /> -->

    <!-- Educareバナー -->
    <TeCommonBanerEducare5000 v-if="isBannerEducare" />
  </div>
</template>

<script lang="ts">
import TeCommonBannerCrowdloan from '~/components/Te/TeCommon/Banner/Crowdloan/TeCommonBannerCrowdloan.vue'
import TeCommonBanerEducare5000 from '~/components/Te/TeCommon/Banner/TeCommonBannerEducare/TeCommonBanerEducare5000.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleInfo } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faCircleInfo,
    }
  },
  props: {
    course: {
      type: Object,
    },
    installment: {
      type: Number,
      default: null,
    },
    installmentsSocial: {
      type: Boolean,
      default: false,
    },
    installmentsSocial8Week: {
      type: Boolean,
      default: false,
    },
    twelveWeek: {
      type: Boolean,
      default: false,
    },
    fourLitePayments: {
      type: Boolean,
      default: false,
    },
    onePlan: {
      type: Boolean,
      default: false,
    },
    isBannerEducare: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    addComma(value: number) {
      return value ? value.toLocaleString() : '-'
    },
  },
  computed: {
    plans(): any {
      return this.course ? this.course.attributes.plans : null
    },
    social4WeeksPlan(): object {
      return this.plans
        ? this.plans.social_4weeks
        : { price_for_max_installment: '-' }
    },
    social8WeeksPlan(): object {
      return this.plans
        ? this.plans.social_8weeks
        : { price_for_max_installment: '-' }
    },
    social12WeeksPlan(): object {
      return this.plans
        ? this.plans.social_12weeks
        : { price_for_max_installment: '-' }
    },
    student4WeeksPlan(): object {
      return this.plans
        ? this.plans.student_4weeks
        : { price_for_max_installment: '-' }
    },
    lite12WeeksPlan(): object {
      return this.plans && this.plans.lite_12weeks
        ? this.plans.lite_12weeks
        : { price_for_max_installment: '-' }
    },
  },
  components: {
    TeCommonBannerCrowdloan,
    TeCommonBanerEducare5000,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
